import React from 'react';
import LandingPage from './components/LandingPage';
import PressKitPage from './components/pages/PressKitPage';
import BrandManualPage from './components/pages/BrandManualPage';

// Path-based page switch — deliberately not a router. The Netlify SPA rewrite
// serves index.html for every path; anything unrecognised (including
// /news/<slug>, which LandingPage handles itself) falls through to the
// landing page.
function App() {
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path === '/press') return <PressKitPage />;
  if (path === '/brand') return <BrandManualPage />;
  return <LandingPage />;
}

export default App;
